import { useCallback, useMemo } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
export var useAllowedActions = function () {
    var user = useAuth0().user;
    var isAllowed = useCallback(function (allowedAction) {
        var userActions = (user === null || user === void 0 ? void 0 : user['https://app.ofca.io/allowed-actions']) || [];
        var actions = Array.isArray(allowedAction) ? allowedAction : [allowedAction];
        return actions.some(function (action) { return userActions.includes(action); });
    }, [user]);
    var allowedActions = useMemo(function () { return user === null || user === void 0 ? void 0 : user['https://app.ofca.io/allowed-actions']; }, [user]);
    return {
        isAllowed: isAllowed,
        allowedActions: allowedActions
    };
};
